import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, flatMap, map, mergeMap } from 'rxjs/operators';
import { AuthAccount } from '../models/auth-account';
import { ApiService } from '../services/api.service';
import { StorageParameters, StorageService } from '../services/storage.service';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private userService: UserService,
    private api: ApiService,
    private router: Router,
    private storage: StorageService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean | UrlTree
  {
    const routePath = route.routeConfig?.path;
    if (routePath === 'sign' && !this.userService.getUser()?.loginId && !this.storage.getItem(StorageParameters.AccessTokenId)) {
      return true;
    }
    let authUser: AuthAccount;
    return this.api.users.authenticated().pipe(
      mergeMap(res => {
        authUser = res;
        const user = this.userService.getUser();
        return of(user);
      }),
      map(userRes => {
        if (userRes && userRes.loginId !== authUser.loginId) {
          console.log('Different user logged');
          this.userService.logout();
          return false;
        } else {
          this.userService.setUser(authUser);
          if (routePath === 'sign') this.router.navigate(['dash']);
          return true;
        }
      }),
      catchError(err => {
        this.errorHandler(err);
        return of(false);
      })
    );
  }

  errorHandler(err: any) {
    console.log('Guard error: ',err);
    this.userService.logout();
  }

}
